import { Collapse, List, ListItem } from "@mui/material";
import classes from "../../../../css/modules/navigation.module.scss";
import clsx from "clsx";
import { Text } from "../../../Text";
import React from "react";

export const SubMenu = ({ items = [], open, onMenuClick, pathName }) => {
  if (items.length) {
    return (
      <Collapse in={open} timeout={350}>
        <List className={clsx(classes.menu, classes.subMenu)}>
          {items.map((item) => {
            const active = pathName === item.href;
            return (
              <ListItem
                button
                key={item.text}
                className={clsx(classes.menuItem, active && classes.menuItemActive)}
                onClick={() => onMenuClick(item)}
              >
                {item.icon && <span className={item.icon} />}
                <span>
                  <Text value={item.text} />
                </span>
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    );
  }
  return null;
};
